import { FC, useState } from "react";

import { copy } from "shared/assets";
import { Weight } from "shared/assets/icons";
import { Card, Modal } from "shared/components";
import { EditUserBodyPreferencesForm, UserBodyPreferences } from "Bands/containers";

const bodyCopy = copy.userBodyPreferences;

export const BodyPreferences: FC = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Card icon={Weight} title={bodyCopy.title}>
      <UserBodyPreferences handleShowModal={setShowModal} />
      {showModal && (
        <Modal icon={Weight} title={bodyCopy.title} handleClose={() => setShowModal(false)}>
          <EditUserBodyPreferencesForm handleClose={() => setShowModal(false)} />
        </Modal>
      )}
    </Card>
  );
};
